import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormInput from '../../Form/FormInput';
import { IFormError } from '../../../constants/Interfaces';
import PhoneInput from '../../Form/PhoneInput';
import { getUserLocation } from 'experience/redux/actions/ExperienceUserLocationActions';
import { useDispatch } from 'react-redux';
import { Field } from 'react-final-form';

interface IEmailAndPhoneInputGroup {
  inputColSizeSm: number;
  inputColSizeMd?: number;
  fieldError?: IFormError;
}

const EmailAndPhoneInputGroup: React.FC<IEmailAndPhoneInputGroup> = ({
  inputColSizeSm,
  inputColSizeMd,
  fieldError,
}) => {
  const { t } = useTranslation();
  const [country, setCountry] = useState('lt');
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const response: any = await dispatch(getUserLocation());
      if (response.data.country) {
        setCountry(response.data.country);
      }
    })();
  }, []);

  return (
    <>
      <Row>
        <Col sm={inputColSizeSm} md={inputColSizeMd}>
          <FormInput
            size='sm'
            label={t('user_form_label_email')}
            name='email'
            type='text'
            fieldError={fieldError}
          />
        </Col>
      </Row>

      <Row>
        <Col sm={inputColSizeSm} md={inputColSizeMd}>
          <Field name='phoneNumberIsValid' subscription={{}}>
            {({ input: validInput }) => (
              <PhoneInput
                name='phoneNumber'
                defaultCountry={country.toLowerCase()}
                type='text'
                label={t('user_form_label_phone')}
                errorDisplayType='basic'
                className='client-modal'
                onBlur={(_e: React.FocusEvent<HTMLInputElement>, isValid: boolean) =>
                  validInput.onChange(isValid)
                }
              />
            )}
          </Field>
        </Col>
      </Row>
    </>
  );
};

export default EmailAndPhoneInputGroup;
